<div class="row">
    <div *ngFor="let deskNumber of sortByDeskNumber(desks)">
        <div class="btn btn-teal btn-sm mx-1 mb-1">
            {{ deskNumber }}
        </div>
    </div>
</div>
